import { Component, OnInit } from '@angular/core';
import { SetDateLegalRequirementComponent } from '../set-date-legal-requirement/set-date-legal-requirement.component';
import { NbDialogService } from '@nebular/theme';
import { DependencesService } from '../../../services/dependences.service';
import { LocalDataSource } from 'ng2-smart-table';
import { CustomRendererComponent } from './custom-renderer.component';
import { MunicipalLegalRequirementComponent } from './municipal-legal-requirement/municipal-legal-requirement.component';
import {CustomEnabledRequirementComponent} from './municipal-legal-requirement/custom-enabled-requirement/custom-enabled-requirement.component';
import {UpdateLegalRequirementComponent} from './update-legal-requirement/update-legal-requirement.component';
import {FileManagerRequirementComponent} from './file-manager-requirement/file-manager-requirement.component';
import { ActivatedRoute } from '@angular/router';
import { StationService } from '../../../services/stations.service';
import { AgreementsComponent } from './agreements/agreements.component';

@Component({
  selector: 'ngx-legal-requirements',
  templateUrl: './legal-requirements.component.html',
  styleUrls: ['./legal-requirements.component.scss'],
})
export class LegalRequirementsComponent implements OnInit {
  stationId: string;
  data: any = [];
  showAllItems = false;
  attrAux = {
    withPreferences: false,
    dependenceMunicipalId: '2dMz1J0dgyYR3awBl1CI',
    selectedDependenceId: '',
    loading: false,
    dependencies: [],
    requirements: [],
    requirementsCopy: [],
    filter: {
      status: 'all',
      stage: 'all',
    },
  };

  settings = {
    actions: false,
    columns: {
      // enabled: {
      //   title: 'Quitar',
      //   type: 'custom',
      //   filter: false,
      //   renderComponent: CustomEnabledRequirementComponent,
      // },
      name: {
        title: 'Nombre',
        filter: true
      },
      stage: {
        title: 'Etapa',
        filter: true,
      },
      periodicity: {
        title: 'Periodicidad',
        filter: true
      },
      actions: {
        title: 'Acciones',
        type: 'custom',
        renderComponent: CustomRendererComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => this.open(row) );
          // instance.cancelDeliver.subscribe(row => this.cancelDeliverConfirmation(row) );
          instance.editRequirement.subscribe(row => this.editRequirement(row) );
          instance.openFileManagerByRequirement.subscribe(row => this.openFileManagerByRequirement(row) );
          instance.agreement.subscribe(row => this.openAgreement(row) );
        },
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };

  source: LocalDataSource = new LocalDataSource;
  dataLoaded = false;

  constructor(
    private dialogService: NbDialogService,
    private dependenciesService: DependencesService,
    private route: ActivatedRoute,
    private stationService: StationService,
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  async ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.init(); 
  }

  async init() { await this.index(); }

  async index() {
    this.attrAux.loading = true;
    const [error, result] = await this.dependenciesService.dependencesAndPreferences(this.stationId);
    this.attrAux.loading = false;
    if (error) return console.error(error);
    this.data = result.data;
    this.attrAux.selectedDependenceId = this.attrAux.selectedDependenceId || result.data[0].id;
    const dependence = await this.data.find(dependence => dependence.id === this.attrAux.selectedDependenceId)
    dependence.preferences.length ? this.loadDataTable(dependence.preferences, true) : this.loadDataTable(dependence.requirements)
  }

  loadDataTable (requirements: any, preferences = false) {
    this.source = requirements.filter(item => {
      if (preferences) {
        if (item.requirement) {
          if (item.disabled && !this.showAllItems) return false
          item.name = item.requirement.name
          item.stage = item.requirement.stage
          item.delivered = item.requirement.deliverables.find(deliverable => deliverable.delivered)
          item.withCalendar = !item.requirement.deliverables.length
        } else {
          if (item.disabled && !this.showAllItems) return false
          item.name = item.data.name
          item.stage = item.data.stage
          item.delivered = item.deliverables.find(deliverable => deliverable.delivered)
          item.withCalendar = !item.deliverables.length
        }
      } else {
        item.disabled = false
        item.delivered = item.deliverables.find(deliverable => deliverable.delivered)
        item.withCalendar = !item.deliverables.length
      }
      return item
    })
  }

  async getRequirementByDependenceIdAndStation () {
    const dependence = await this.data.find(dependence => dependence.id === this.attrAux.selectedDependenceId)
    dependence.preferences.length ? this.loadDataTable(dependence.preferences, true) : this.loadDataTable(dependence.requirements)
  }

  async open(requirement: any) {
    this.dialogService.open(SetDateLegalRequirementComponent, { hasScroll: true, context: { stationId: this.stationId, dependenceId: this.attrAux.selectedDependenceId, requirement } }).onClose.subscribe(store => store ? this.index() : 0);
  }

  addMunicipalLegalRequirement() {
    this.dialogService.open(MunicipalLegalRequirementComponent, { hasScroll: true, context: { stationId: this.stationId, dependenceId: this.attrAux.selectedDependenceId } }).onClose.subscribe(store => store ? this.index() : 0);
  }

  async editRequirement(requirement: any) {
    this.dialogService.open(UpdateLegalRequirementComponent, { hasScroll: true, context: { stationId: this.stationId, requirement } }).onClose.subscribe(store => store ? this.index() : 0);
  }

  async openFileManagerByRequirement(requirement: any) {
    const deliverables = (requirement.requirement) ? requirement.deliverables.concat(requirement.requirement.deliverables) : requirement.deliverables
    this.dialogService.open(FileManagerRequirementComponent, { hasScroll: true, context: { deliverables, requirement, stationId: this.stationId } }).onClose.subscribe(() => this.index());
  }

  async openAgreement(requirement: any) {
    this.dialogService.open(AgreementsComponent, { hasScroll: true, context: { requirement, stationId: this.stationId } }).onClose.subscribe(() => this.index());
  }

  async savePreferences() {
    this.attrAux.loading = true;
    const dependence = await this.data.find(dependence => dependence.id === this.attrAux.selectedDependenceId);
    const requirements = dependence.preferences.length ? dependence.preferences : dependence.requirements
    const [error] = await this.dependenciesService.storeDependenceRequirementsPreferences(this.stationId, { requirements });
    this.attrAux.loading = false;
    if (error) return console.error(error);
    return this.index();
  }

  async showAll() {
    const dependence = await this.data.find(dependence => dependence.id === this.attrAux.selectedDependenceId)
    dependence.preferences.length ? this.loadDataTable(dependence.preferences, true) : this.loadDataTable(dependence.requirements)
  }

}
